import { useContextMenuStore } from "../store/context-menu.store.js";
import { useLayoutStore } from "../store/layout.store.js";

export interface AvatarMenuContext {
  placement?: "name-cell" | "near-anchor";
  position: {
    x: number;
    y: number;
  };
  userId: string;
}

export const useAvatarMenu = () => {
  const { avatarMenu, closeAvatarMenu, openAvatarMenu } = useLayoutStore();
  const { hideContextMenu } = useContextMenuStore();

  const showAvatarMenu = (
    userId: string,
    position: AvatarMenuContext["position"],
    placement: AvatarMenuContext["placement"] = "near-anchor"
  ) => {
    hideContextMenu();

    const currentContext = avatarMenu?.context as AvatarMenuContext | null;
    const isSameAvatarMenuOpen = currentContext?.userId === userId;

    if (isSameAvatarMenuOpen) {
      closeAvatarMenu();
      return;
    }

    openAvatarMenu({
      placement,
      position,
      userId,
    });
  };

  return { hideAvatarMenu: closeAvatarMenu, showAvatarMenu };
};
